// src/TechnicalSupport.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var TechnicalSupport_default = createIcon({
  displayName: "TechnicalSupport",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.1591 2.00636C10.8747 1.99475 10.5871 1.99926 10.2958 2.01807C6.28069 2.2787 3.1941 5.61067 2.86222 9.56886L2.84855 9.55128L2.00675 19.8384C1.91175 21.0034 2.83189 22.0005 4.00089 22.0005H12.829C13.381 22.0005 13.829 21.5525 13.829 21.0005C13.829 20.4485 13.381 20.0005 12.829 20.0005H10.829C7.51501 20.0005 4.82901 17.3145 4.82901 14.0005V13.0005C4.82901 11.8955 5.72401 11.0005 6.82901 11.0005H14.829C15.934 11.0005 16.829 11.8955 16.829 13.0005V16.0005H12.7411C12.5295 15.4019 11.9639 15.0014 11.329 15.0005C10.9312 15.0005 10.5497 15.1585 10.2684 15.4398C9.98705 15.7211 9.82901 16.1027 9.82901 16.5005C9.83007 17.2865 10.4376 17.9384 11.2216 17.9946C11.2573 17.9985 11.2931 18.0005 11.329 18.0005H17.829H18.829C19.929 18.0005 20.829 17.1005 20.829 16.0005V14.0005C20.829 12.9005 19.929 12.0005 18.829 12.0005V10.0005C18.829 5.69268 15.4243 2.18045 11.1591 2.00636Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  TechnicalSupport_default
};
